import Axios from 'axios';
import URL from '../../Environment';
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import './vision.css';

const Vision = () => {
  const [visionData, setVisionData] = useState(null);
  const [visionLoading, setVisionLoading] = useState(true);
  const [errorVision, setVisionError] = useState(null);

  useEffect(() => {
    const fetchVisionData = async () => {
      try {
        const response = await Axios.get(`${URL}api/Vision/getvisionsDataInfo`);
        console.log('Response:', response.data);
        setVisionData(response.data);
        setVisionLoading(false);
      } catch (error) {
        console.log('Error:', error);
        setVisionError(error);
        setVisionLoading(false);
      }
    };

    fetchVisionData();
  }, []);

  if (visionLoading) {
    return <div>Loading...</div>;
  }

  if (errorVision) {
    return <div>Error: {errorVision.message}</div>;
  }

  return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
              <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <a href="vision" className="a-breadcrumbs">วิสัยทัศน์และพันธกิจ</a>
            </div>
          </div>
        </div>
      </section>

      <section className="page-section">
        <div className="container">
          <div className="row">
            <div className="col-md-9 col-sm-9 mb-sm-50 Infomation-Font" style={{fontFamily: '"Cordia New"'}}>
              {visionData ? (
                <>
                  {/* <br/> */}
                  <div className="divider gray left mt-20 mb-25" />
                  <div 
                    style={{
                        marginBottom: '0rem',  // ปรับค่านี้ ค่าปกติคือ 1.5-1.6
                      }}
                    dangerouslySetInnerHTML={{ __html: visionData.description }}
                  />
                </>
              ) : (
                <div className="text-center">
                  <p>ไม่พบข้อมูล</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Vision;